import React, { useState } from "react"
import classNames from "classnames"
import { FaCheckCircle, FaInfoCircle, FaTimes } from "react-icons/fa"

export interface SystemMessageProps {
  text: string
  kind?: "information" | "success" | "error"
  onHide?: () => void
  animate?: boolean
}
const getIcon = (kind?: "information" | "success" | "error") => {
  switch (kind) {
    case "success":
      return FaCheckCircle
    case "information":
    case "error":
    default:
      return FaInfoCircle
  }
}

export const SystemMessage: React.FC<SystemMessageProps> = ({
  text,
  kind = "information",
  onHide,
  animate = true,
}) => {
  const [isClosed, setIsClosed] = useState(false)

  const className = classNames({
    "flex items-center justify-between gap-4 p-4 min-w-[288px] max-w-sm mb-4 rounded pointer-events-auto":
      true,
    "bg-system-message-success-bg text-system-message-success-text":
      kind === "success",
    "bg-system-message-information-bg text-system-message-information-text":
      kind === "information",
    "bg-system-message-error-bg text-system-message-error-text":
      kind === "error",
    "animate-slide-in-out hover:[animation-play-state:paused]": animate,
    "animate-slide-out hover:[animation-play-state:running]": isClosed,
  })

  const Icon = getIcon(kind)

  return (
    <div
      className={className}
      style={{
        transform: animate ? `translateX(calc(100% + 16px))` : undefined,
      }}
      onAnimationEnd={(): void => {
        if (onHide) onHide()
      }}
    >
      <Icon className="flex h-4 w-4 shrink-0" />
      <span className="grow text-sm leading-5">{text}</span>
      <FaTimes
        className="flex h-5 w-5 shrink-0 cursor-pointer justify-center self-start p-1 text-gray-500 hover:text-inherit"
        onClick={(): void => {
          setIsClosed(true)
        }}
      />
    </div>
  )
}
